<div class="modal-dialog modal-lg">
    <div class="modal-content">
    
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Importação de registros em massa</h4>
        <ngx-loading-bar ref="http" diameter=32px height=8px  color=#ff681c>
        </ngx-loading-bar>
        <button type="button" class="close" data-dismiss="modal" (click)="okImportar(importar)">&times;</button>
          
    </div>
    <!-- Modal body -->
    <div class="modal-body">
        <p>Para importar os eleitores, selecione abaixo o arquivo (.csv) e em seguida confira os dados.</p>
        
        <input type="file" #importar class="form-control" accept=".csv" (change)="importarCsv($event)">
        <nav *ngIf="criticaValidacao.length > 0 || newEleitores.length > 0 || duplicados.length > 0 || enviados.length > 0" class="mt-3">
            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                <a *ngIf="criticaValidacao.length > 0" class="nav-item nav-link" [ngClass]="ativaNavValidacao == true ? 'active' : '' " 
                    id="nav-validacao-tab" data-toggle="tab" href="#nav-validacao" role="tab" aria-controls="nav-validacao" aria-selected="false">
                    Validação
                </a>
                <a *ngIf="eleitoresSemPlano.length > 0" class="nav-item nav-link" [ngClass]="ativaNavSemPlano === true ? 'active' : '' " 
                    id="nav-sem-plano-tab" data-toggle="tab" href="#nav-sem-plano" role="tab" aria-controls="nav-sem-plano" 
                    aria-selected="true">
                    Sem Plano ou Agrupador
                </a>
                <a *ngIf="newEleitores.length > 0 && enviados.length === 0" class="nav-item nav-link" 
                    [ngClass]="ativaNavEnviar == true ? 'active' : '' " id="nav-enviar-tab" data-toggle="tab" href="#nav-enviar" 
                    role="tab" aria-controls="nav-enviar" aria-selected="false">
                    Enviar
                </a>
                <a *ngIf="duplicados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavDuplicados === true ? 'active' : '' " 
                    id="nav-duplicados-tab" data-toggle="tab" href="#nav-duplicados" role="tab" aria-controls="nav-duplicados" 
                    aria-selected="true">
                    Duplicados
                </a>
                <a *ngIf="enviados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavEnviados === true ? 'active' : '' " 
                    id="nav-enviados-tab" data-toggle="tab" href="#nav-enviados" role="tab" aria-controls="nav-enviados" aria-selected="true">
                    Enviados
                </a>
            </div>
        </nav>
        <div *ngIf="criticaValidacao.length > 0 || newEleitores.length > 0 || duplicados.length > 0 || enviados.length > 0" class="tab-content" id="nav-tabContent">
            <div *ngIf="criticaValidacao.length > 0" class="tab-pane fade" [ngClass]="ativaNavValidacao == true ? 'show active' : '' " id="nav-validacao" role="tabpanel">
                <div class="mt-2">
                    <div class="alert alert-danger mt-2" role="alert">
                        <p class="mb-1">Os eleitores não passaram em alguma das seguintes validações:</p>
 
                        <br/>
                        <p class="mb-0">Validação 1: É necessário cadastrar um login para o eleitor.</p>
                        <p class="mb-0">Validação 2: Não é permitido o uso de espaços no login.</p>
                        <p class="mb-0">Validação 3: Os únicos caracteres especiais permitidos são "@", "-", "_" e "."!</p>
                        <p class="mb-0">Validação 4: É necessário cadastrar uma senha quando não há integração na eleição.</p>
                        <p class="mb-0">Validação 5: UF registrado não existe ou está incorreto (Informe a sigla em caixa alta).</p>
                        <p class="mb-0">Validação 6: É necessário cadastrar um e-mail válido.</p>
                        <p class="mb-0">Validação 7: É necessário preencher as Informações de Autenticação do eleitor.</p>
                        <p class="mb-0">Validação 8: Logins duplicados.</p>

                    </div>                    
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Login</th>
                                <th>Email</th>
                                <th>Crítica Validação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let valida of criticaValidacao">
                                <td>{{valida.eleitorCriticado.login}}</td>
                                <td>{{valida.eleitorCriticado.email}}</td>
                                <td>{{valida.critica}}</td>
                            </tr>
                        </tbody>
                    </table>                             
                </div>
            </div>

            <div *ngIf="eleitoresSemPlano.length > 0" class="tab-pane fade" [ngClass]="ativaNavSemPlano === true ? 'show active' : '' " id="nav-sem-plano" role="tabpanel">
                <div class="alert alert-warning mt-2" role="alert">
                    <p class="mb-0">O(s) eleitor(es) a seguir não possuem Plano ou Agrupador associado(s).</p>
                    <p class="mb-0">Caso deseje seguir com a importação deles, pressione "seguir" para que eles sejam adicionados à aba "Enviar".
                        Caso contrário, descarte o arquivo e faça as correções necessárias.</p>
                </div>
                <div class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Login</th>
                                <th>Informações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eleitor of eleitoresSemPlano">
                                <td>{{eleitor.login}}</td>
                                <td><b>Email: </b>{{eleitor.email}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button class="btn-custom btn btn-success mt-3" (click)="salvarEleitoresSemPlano()">
                    Seguir sem Plano ou Agrupador
                </button>
            </div>

            <div *ngIf="newEleitores.length > 0" class="tab-pane fade" [ngClass]="ativaNavEnviar == true ? 'show active' : '' " id="nav-enviar" role="tabpanel">
                <div class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th class="cabecalho">Login</th>
                                <th class="cabecalho" >Informações</th>
                                <th class="cabecalho" *ngIf="eleicao?.temPlanos">Plano</th>
                                <th class="cabecalho" *ngIf="eleicao?.temPlanos">Agrupador</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eleitor of newEleitores">
                                <td class="cabecalho alinhamentoVertical">{{eleitor.login}}</td>
                                <td><b>Email: </b>{{eleitor.email}}</td>
                                <td class="cabecalho alinhamentoVertical" *ngIf="eleicao?.temPlanos">{{eleitor.plano}}</td>
                                <td class="cabecalho alinhamentoVertical" *ngIf="eleicao?.temPlanos">{{eleitor.agrupador}}</td>
                            </tr>
                        </tbody>
                    </table>   
                </div>
                        <p>Total de Registros: {{ totalRegistros }}</p>
                        <p>Registros Processados: {{ registrosProcessados }} de {{ totalRegistros }}</p>
                <button *ngIf="newEleitores.length > 0" class="btn-custom btn btn-success mt-3" (click)="importarList()">
                    Salvar
                </button>
            </div>

            <div *ngIf="duplicados.length > 0" class="tab-pane fade" [ngClass]="ativaNavDuplicados === true ? 'show active' : '' " id="nav-duplicados" role="tabpanel">
                <div class="alert alert-danger mt-2" role="alert">
                    <p class="mb-0">Os eleitores abaixo já estão cadastrados.</p>
                </div>
                <div *ngIf="duplicados.length > 0" class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Login</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eleitor of duplicados">
                                <td>{{eleitor.login}}</td>
                            </tr>
                        </tbody>
                    </table>              
                </div>
            </div>

            <div *ngIf="enviados.length > 0" class="tab-pane fade" [ngClass]="ativaNavEnviados === true ? 'show active' : '' " id="nav-enviados" role="tabpanel">
                <div class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Login</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eleitor of enviados">
                                <td>{{eleitor.login}}</td>
                            </tr>
                        </tbody>
                    </table>              
                </div>
            </div>

        </div>
        <hr>
        <button *ngIf="newEleitores.length === 0" class="btn-custom btn btn-success" data-dismiss="modal" (click)="okImportar(importar)">
            Ok
        </button>
        <button class="btn-custom btn btn-light mr-2" (click)="zerarInputFile(importar)">
            Descartar arquivo
        </button>  
    </div>        
    </div>
</div>